import Overlay from './overlay';

function redirigirSegunTipoUrl(url, options) {
  if (url.toUpperCase().startsWith('HTTP') || url.indexOf('?') !== -1) {
    window.location = url;
  } else {
    window.location.pathname = url;
  }

  if (window.location.pathname === url && options.refresh) {
    window.location.reload();
  }
}

// eslint-disable-next-line import/prefer-default-export
export function redirectTo(url, xoptions) {
  const options = { overlay: true, ...xoptions };

  if (options.overlay) {
    new Overlay('body').show();
    // Sin este setTimeout no me sale el overlay
    setTimeout(() => {
      redirigirSegunTipoUrl(url, xoptions);
    }, 100);
  } else {
    redirigirSegunTipoUrl(url, xoptions);
  }
}
